import { useEffect, useState } from "react";
import AgoraRTC, { IAgoraRTCClient } from "agora-rtc-sdk-ng";
import { join } from "path";

const Live: React.FC = () => {
  const client: IAgoraRTCClient = AgoraRTC.createClient({
    mode: "live",
    codec: "vp8",
  });
  const [userRole, setUserRole] = useState<any>("");

  var options = {
    // Pass your app ID here.
    appId: "8f73a9dfa4a947758086cf15e79d91ba",
    // Set the channel name.
    channel: "demo_channel_name",
    // Pass a token if your project enables the App Certificate.
    token: null,
    // Set the user role in the channel.
    role: userRole,
  };
  useEffect(() => {
    if (userRole == "audience") {
      const uid = client.join(
        "8f73a9dfa4a947758086cf15e79d91ba",
        "demo_channel_name",
        "0068f73a9dfa4a947758086cf15e79d91baIABM7QrNM6O0IxiQs03Cmy0buFWZ+OvqMKxmiKp7yiejX44kO3kAAAAAEADEZWnpySS3YAEAAQDHJLdg",
        null
      );
      client.setClientRole(userRole);
      client.on("user-published", async (user, mediaType) => {
        await client.subscribe(user, mediaType);

        if (mediaType === "video") {
          // Get `RemoteVideoTrack` in the `user` object.
          const remoteVideoTrack: any = user.videoTrack;
          // Dynamically create a container in the form of a DIV element for playing the remote video track.
          const playerContainer = document.createElement("div");
          // Specify the ID of the DIV container. You can use the `uid` of the remote user.
          playerContainer.id = user.uid.toString();
          playerContainer.style.width = "640px";
          playerContainer.style.height = "480px";
          document.body.append(playerContainer);

          // Play the remote video track.
          // Pass the DIV container and the SDK dynamically creates a player in the container for playing the remote video track.
          remoteVideoTrack.play(playerContainer);
        }
      });
    }
  }, [userRole]);

  const Host = async () => {
    client.setClientRole("host");
    const uid = await client.join(
      "8f73a9dfa4a947758086cf15e79d91ba",
      "demo_channel_name",
      "0068f73a9dfa4a947758086cf15e79d91baIABM7QrNM6O0IxiQs03Cmy0buFWZ+OvqMKxmiKp7yiejX44kO3kAAAAAEADEZWnpySS3YAEAAQDHJLdg",
      null
    );
    AgoraRTC.createScreenVideoTrack({
      encoderConfig: "1080p_1",
    }).then((screenVideoTrack: any) => {
      /** ... **/
      client.publish([screenVideoTrack]);
    });
  };

  const Join = () => {
    setUserRole("audience");
  };

  return (
    <div>
      <button onClick={() => Host()}>Host</button>
      <button onClick={() => Join()}>Join</button>
      <video id="videoMessage"></video>
    </div>
  );
};

export default Live;
